/**
 * TanStack Query hooks for `device-masking-detection-emulator-modified-rom-roo`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	deviceMaskingDetectionEmulatorModifiedRomRooQueryKeys,
	type CreateDeviceMaskingDetectionEmulatorModifiedRomRooBody,
	type ListDeviceMaskingDetectionEmulatorModifiedRomRooResponse,
	type DeviceMaskingDetectionEmulatorModifiedRomRooRow,
} from "./api";

export function useDeviceMaskingDetectionEmulatorModifiedRomRooList(): UseQueryResult<ListDeviceMaskingDetectionEmulatorModifiedRomRooResponse, Error> {
	return useQuery({
		queryKey: deviceMaskingDetectionEmulatorModifiedRomRooQueryKeys.list(),
		queryFn: list,
	});
}

export function useDeviceMaskingDetectionEmulatorModifiedRomRooCreate(): UseMutationResult<DeviceMaskingDetectionEmulatorModifiedRomRooRow, Error, CreateDeviceMaskingDetectionEmulatorModifiedRomRooBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: deviceMaskingDetectionEmulatorModifiedRomRooQueryKeys.all });
		},
	});
}

export function useDeviceMaskingDetectionEmulatorModifiedRomRooDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: deviceMaskingDetectionEmulatorModifiedRomRooQueryKeys.all });
		},
	});
}
